
export default {
    namespaced: true,
    state: {
        categoryList: [],
        exportList: [],
        deleteList: [],
        isLoad: false,
        newCounter: 10000,
        issetNoSaveChanges: false,
        isExport: false
    },
    getters: {
        ISSET_NO_SAVE_CHANGES: state => {
            return state.issetNoSaveChanges;
        },
        NEW_COUNTER: state => {
            return state.newCounter;
        },
        IS_LOAD: state => {
            return state.isLoad;
        },
        IS_EXPORT: state => {
            return state.isExport;
        },
        DELETE_LIST: state => {
            return state.deleteList;
        },
        CATEGORY_LIST: state => {
            return state.categoryList;
        },
        EXPORT_LIST: state => {
            return state.exportList;
        }
    },
    mutations: {
        ISSET_NO_SAVE_CHANGES: (state, payload) => {
            return state.issetNoSaveChanges = payload;
        },
        NEW_COUNTER: (state) => {
            return state.newCounter++;
        },
        IS_LOAD: (state, payload) => {
            return state.isLoad = payload;
        },
        IS_EXPORT: (state, payload) => {
            return state.isExport = payload;
        },
        DELETE_LIST: (state, payload) => {
            return state.deleteList = payload;
        },
        CATEGORY_LIST: (state, payload) => {
            return state.categoryList = payload;
        },
        EXPORT_LIST: (state, payload) => {
            return state.exportList = payload;
        }
    },
    actions: {
        GET_ALL: async ({state, commit}, payload) => {
            payload.th.showOverlay ++
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/goods-category-list',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    let skeleton = [{
                        id: 0,
                        name: 'Категории',
                        ruName: 'Категории',
                        children: [],
                        level: 0
                    }];
                    skeleton[0].children = responseData.data;
                    payload.th.deactivateForm()
                    commit('CATEGORY_LIST', skeleton);
                    console.log(state.categoryList)
                    state.issetNoSaveChanges = false;
                },
                getResponse: () => {
                    payload.th.showOverlay --
                },
            });
        },
        GET_EXPORTS_ALL: async ({commit, dispatch}, params) => {
            let url = '/product-category-export';
            const queryParams = [];
            Object.keys(params).map((key,index) => {
                if(params[key] !== ''){
                    queryParams.push(`${key}=${encodeURIComponent(params[key])}`)
                }
            })
            const sQueryParams = queryParams.join('&')
            url = `${url}?${sQueryParams}`
            dispatch('SEND_GET', {
                url,
                getSuccessResponse: (responseData)=>{
                    commit('EXPORT_LIST', responseData.content);
                },
                showSuccessMessage: false
            }, { root: true });
        },
        SAVE: async ({state, dispatch}, payload) => {
            state.isLoad = true;
            payload.th.showOverlay ++
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/goods-category-save',
                parameter: {
                    'categoryList': state.categoryList[0].children,
                    'deleteList': state.deleteList
                },
                th: payload.th,
                showSuccessMessage: true,
                getSuccessResponse: (responseData) => {
                    console.log(responseData)
                    payload.th.deactivateForm();
                    state.deleteList = [];
                    state.issetNoSaveChanges = false;
                },
                getResponse: () => {
                    state.isLoad = false;
                    dispatch('GET_ALL', {th: payload.th});
                    payload.th.showOverlay --
                },
            });
        },
        SEARCH_AND_DO: function ({dispatch}, params) {
            for (let key in params.cList) {
                if (params.cList[key].id == params.id) {
                    params.func(params.cList, key);
                } else {
                    if (params.cList[key].children != []) {
                        let children = params.cList[key].children;
                        dispatch('SEARCH_AND_DO', {
                            id: params.id,
                            func: params.func,
                            cList: children
                        });
                    }
                }
            }
        },
        EXPORT_T: async function ({state, dispatch}, payload) {
            state.isExport = true;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/product-category-export/export',
                th: payload.th,
                parameter: {
                    'category': payload.category,
                },
                showSuccessMessage: true,
                getResponse: () => {
                    state.isExport = false;
                    dispatch('GET_EXPORTS_ALL', {category: payload.category});
                },
            });
        },
        EXPORT: async({dispatch, state}, payload) => {
            payload.th.showOverlay++;
            return dispatch('SEND_POST', {
                url: '/product-category-export/export',
                parameter: {
                    'category': payload.category,
                },
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    if (responseData == 7) console.log(responseData);
                    if (payload.handleSuccessResponse !== undefined) {
                        payload.handleSuccessResponse();
                    }
                    state.isExport = false;
                    dispatch('GET_EXPORTS_ALL', {category: payload.category});
                },
                getResponse: () => {
                    state.isExport = false;
                    dispatch('GET_EXPORTS_ALL', {category: payload.category});
                    payload.th.showOverlay--;
                },
            }, { root: true });
        },
        DELETE_EXPORT: ({dispatch, commit, state}, {id, th}) => {
            return dispatch('SEND_DELETE', {
                url: '/product-category-export/' + id,
                getSuccessResponse: ()=>{
                    let items   = state.exportList.filter((item)=>{
                        return item.id !== id
                    })
                    commit('EXPORT_LIST', items);
                },
                showSuccessMessage: true,
                th
            }, { root: true });
        },
    }
}